import script from "./QModalCounterparties.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalCounterparties.vue?vue&type=script&setup=true&lang=js"

import "./QModalCounterparties.vue?vue&type=style&index=0&id=5254e32c&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5254e32c"]])

export default __exports__